import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MessageService } from 'primeng/components/common/messageservice';

import { environment } from '../../../environments/environment';
import { BaseService } from '../base/util/base.service';


@Injectable()
export class FinalizarGtoService extends BaseService {

    constructor(
        public http: HttpClient,
        public messageService: MessageService) {
        super(http, messageService);
    }

    public detalharGto(idGto) {
        const url = `${environment.urlApi}gto/${idGto}`;

        return this.get(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/gto-finalizar/gto-finalizar.service.ts